<template>
  <ul
    :style="{ left: rightMenuLeft + 'px', top: rightMenuTop + 'px' }"
    class="tags-menu"
  >
    <li @click="handleRightMenu('refresh', selectedTag)">
      {{ $t('navbar.refresh') }}
    </li>
    <li
      v-if="!(selectedTag.meta && selectedTag.meta.affix)"
      @click="handleRightMenu('close', selectedTag)"
    >
      {{ $t('navbar.close') }}
    </li>
    <li @click="handleRightMenu('others', selectedTag)">
      {{ $t('navbar.closeOther') }}
    </li>
    <li @click="handleRightMenu('all')">{{ $t('navbar.closeAll') }}</li>
    <li
      v-if="!(selectedTag.meta && selectedTag.meta.affix)"
      @click="handleRightMenu('left', selectedTag)"
    >
      {{ $t('navbar.closeLeftSide') }}
    </li>
    <li @click="handleRightMenu('right', selectedTag)">
      {{ $t('navbar.closeRightSide') }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    rightMenuLeft: {
      type: Number,
      default: 0
    },
    rightMenuTop: {
      type: Number,
      default: 0
    },
    selectedTag: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    handleRightMenu(type, selectedTag) {
      this.$emit('onMenu', type, selectedTag)
    }
  }
}
</script>
